export default "__VITE_ASSET__BFmBifij__"